"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateHandler = void 0;
const formatDateHandler = (date) => {
    const myDate = new Date(date);
    const month = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'][myDate.getMonth()];
    const year = myDate.getFullYear();
    const day = myDate.getDate();
    const formattedDate = `${month} ${day}, ${year}`;
    return formattedDate;
};
exports.formatDateHandler = formatDateHandler;
//# sourceMappingURL=formatDateHandler.js.map